import { Typography } from '@mui/material';

export function SettingsPage() {
  return (
    <Typography variant="h4" component="h1">
      Settings
    </Typography>
  );
}

export default SettingsPage;
